// Re-export the existing ModelApplyNew as ModelApplicationForm
import ModelApplyNew from "../../pages/ModelApplyNew";

export default ModelApplyNew;
